import React from 'react'
import { Menu, MenuItem, Tooltip } from '@mui/material'




const Traductor = ({handleLanguageChange, openMenuIdioma, handleCloseIdioma, idioma, translate}) => {

  const languages = [
    { code: 'es', label: translate('es')},
    { code: 'en', label: translate('en')},
    { code: 'no', label: translate('no_idioma')},
    { code: 'jp', label: translate('jp')},
    { code: 'zh', label: translate('zh')},
    { code: 'fr', label: translate('fr')},
    { code: 'ar', label: translate('ar')},
    { code: 'ru', label: translate('ru')},
    { code: 'pt', label: translate('pt')}
  ]

  return (
   
        <Menu
          anchorEl={openMenuIdioma}
          open={Boolean(openMenuIdioma)}
          onClose={handleCloseIdioma}
        >
          {languages.map(({ code, label }) => (
            <Tooltip
              key={code}
              title={code}
              placement="right"
              arrow
            >
              <MenuItem
                selected={idioma === code}
                onClick={() => {
                  handleLanguageChange(code)
                  handleCloseIdioma()
                }}
              >
                {label}
              </MenuItem>
            </Tooltip>
          ))}
        </Menu>
  )
}

export default Traductor